module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-container register"
  }, [_c('div', {
    staticClass: "login-logo-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/MKD-logo2.jpg"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.toOurWeb()
      }
    }
  })]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      "autoComplete": "on",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.gets('$注册')))])])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px"
    }
  }, [_c('form-list', {
    staticClass: "cm-register",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "store": _vm.UserPage,
      "entity": _vm.UserPage.Entity
    }
  }, [(_vm.name == 1) ? _c('span', {
    staticStyle: {
      "position": "absolute",
      "bottom": "399px",
      "font-size": "14px",
      "font-weight": "700",
      "color": "#606266"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" Wechat ID\r\n               ")]) : (_vm.name == 2) ? _c('span', {
    staticStyle: {
      "position": "absolute",
      "bottom": "399px",
      "font-size": "14px",
      "font-weight": "700",
      "color": "#606266"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" Skype ID\r\n               ")]) : _c('span', {
    staticStyle: {
      "position": "absolute",
      "bottom": "399px",
      "font-size": "14px",
      "font-weight": "700",
      "color": "#606266"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" WhatsApp number\r\n               ")])]), _vm._v(" "), _c('el-button', {
    staticClass: "register-btn",
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.UserPageToUpdate()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$注册')))]), _vm._v(" "), _c('el-form-item', {
    staticClass: "toLogin"
  }, [(_vm.language == 'CN') ? _c('div', [_vm._v("已经有账号了？ "), _c('span', {
    staticStyle: {
      "color": "#4680ff",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.Customerlogin
    }
  }, [_vm._v("登录")])]) : _c('div', [_vm._v("Already have account？ "), _c('span', {
    staticStyle: {
      "color": "#4680ff",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.Customerlogin
    }
  }, [_vm._v("Sign in")])])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74629fe0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/Register.vue
// module id = 1292
// module chunks = 169